"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _theme = _interopRequireDefault(require("../../../theme/theme.styles"));

var _Paragraph = require("./Paragraph.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Paragraph = function Paragraph(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'xs' : _ref$size,
      _ref$weight = _ref.weight,
      weight = _ref$weight === void 0 ? 'normal' : _ref$weight,
      text = _ref.text,
      children = _ref.children,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? 'none' : _ref$transform,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'default' : _ref$color,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$auto = _ref.auto,
      auto = _ref$auto === void 0 ? true : _ref$auto,
      _ref$service = _ref.service,
      service = _ref$service === void 0 ? false : _ref$service,
      _ref$forceMultiline = _ref.forceMultiline,
      forceMultiline = _ref$forceMultiline === void 0 ? false : _ref$forceMultiline,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'occ-paragraph' : _ref$dataTestId;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_theme["default"], null), /*#__PURE__*/_react["default"].createElement(_Paragraph.Occ_Paragraph, {
    size: size,
    weight: weight,
    transform: transform,
    color: color,
    align: align,
    width: width,
    auto: auto,
    service: service,
    forceMultiline: forceMultiline,
    "data-test-id": dataTestId
  }, children ? children : text));
};

var _default = Paragraph;
exports["default"] = _default;